(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3242],{

/***/ 62037:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-demo",
      function () {
        return __webpack_require__(64919);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 64919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ request_demo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/InfoBox.jsx + 3 modules
var InfoBox = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/components/Button.jsx
var Button = __webpack_require__(88749);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(17609);
// EXTERNAL MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx + 7 modules
var StandardField = __webpack_require__(24606);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/RequestDemoForm.jsx




var RequestDemoForm = function(param) {
    var data = param.data, formData = param.formData, changeData = param.changeData, errors = param.errors, consent = param.consent, changeConsent = param.changeConsent, handleSubmit = param.handleSubmit, sending = param.sending, classNameForTextAgreement = param.classNameForTextAgreement;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "form-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "162",
                    height: "40",
                    viewBox: "0 0 162 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            clipPath: "url(#clip0_14_353)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M45.3089 27.3512C51.0171 27.3512 54.4955 24.0774 54.4955 18.5119C54.4955 12.9464 51.0468 9.67263 45.3089 9.67263H39.2439V27.3214H45.3089V27.3512ZM45.1305 6.60715C53.1576 6.60715 57.9442 11.0714 57.9442 18.5417C57.9442 26.0119 53.1874 30.4762 45.1305 30.4762H37.6979C36.5682 30.4762 35.8547 29.7917 35.8547 28.6607V8.42263C35.8547 7.29168 36.5682 6.60715 37.6979 6.60715H45.1305Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M64.1578 20.3869H75.5445C74.9499 17.6786 72.8093 15.8929 69.866 15.8929C66.893 15.8929 64.7524 17.6786 64.1578 20.3869ZM78.5473 21.2202C78.5473 22.4702 77.804 23.1845 76.5553 23.1845H64.0686C64.5741 26.1012 66.7741 28.0357 70.0147 28.0357C72.1255 28.0357 73.7607 27.2024 74.7715 26.0119C75.0986 25.6548 75.485 25.4464 75.9905 25.4464C76.8824 25.4464 77.477 26.0417 77.477 26.9048C77.477 27.2321 77.3581 27.5298 77.1499 27.8274C75.5445 29.7321 73.0174 30.9226 70.0147 30.9226C64.4849 30.9226 60.7983 27.3214 60.7983 21.9941C60.7983 16.6964 64.4551 13.0655 69.8363 13.0655C74.8607 13.0655 78.5473 16.6369 78.5473 21.1905V21.2202Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M108.04 20.5952V28.9881C108.04 30.0298 107.475 30.6548 106.494 30.6548C105.513 30.6548 104.918 30 104.918 28.9881V20.9524C104.918 17.6488 103.521 15.8929 100.904 15.8929C98.1692 15.8929 96.5043 18.0357 96.5043 21.5179V28.9881C96.5043 30.0298 95.9394 30.6548 94.9286 30.6548C94.007 30.6548 93.4124 30 93.4124 28.9881V20.9524C93.4124 17.6488 92.015 15.8929 89.3691 15.8929C86.6339 15.8929 84.969 18.0357 84.969 21.5179V28.9881C84.969 30.0298 84.4041 30.6548 83.3933 30.6548C82.4419 30.6548 81.877 30 81.877 28.9881V14.9405C81.877 13.8691 82.4419 13.244 83.3933 13.244C84.3744 13.244 84.969 13.8691 84.969 14.9405V15.3571H85.0284C86.1285 13.8393 87.9123 13.006 90.0826 13.006C92.6097 13.006 94.4232 14.0476 95.4043 15.9524H95.4638C96.653 14.0774 98.6746 13.006 101.469 13.006C105.869 13.0357 108.04 15.6548 108.04 20.5952Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M128.018 14.9405V29.0774C128.018 34.3452 124.778 37.5 119.486 37.5C116.305 37.5 113.718 36.6072 112.291 34.7619C112.113 34.5238 111.964 34.1667 111.964 33.7798C111.964 32.9167 112.559 32.2917 113.48 32.2917C113.986 32.2917 114.253 32.4702 114.61 32.8274C115.769 33.9881 117.286 34.6429 119.367 34.6429C122.816 34.6429 124.867 32.5893 124.867 29.2262V27.7381H124.807C123.529 29.4941 121.478 30.4762 118.802 30.4762C114.105 30.4762 111.548 27.7083 111.548 22.5298V14.9405C111.548 13.8691 112.142 13.244 113.123 13.244C114.105 13.244 114.64 13.8691 114.64 14.9405V22.2024C114.64 25.7143 116.334 27.5893 119.545 27.5893C122.816 27.5893 124.867 25.2976 124.867 21.5774V14.9405C124.867 13.8691 125.462 13.244 126.413 13.244C127.453 13.244 128.018 13.8691 128.018 14.9405Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M139.286 20.3571C144.935 20.4167 146.927 21.9941 146.927 25.506C146.927 28.8988 144.162 30.8929 139.465 30.8929C135.867 30.8929 133.518 30.1786 131.854 28.631C131.556 28.3333 131.378 27.9464 131.378 27.5298C131.378 26.6369 131.972 26.0417 132.805 26.0417C133.191 26.0417 133.578 26.2202 133.935 26.4881C135.183 27.5595 137.027 28.125 139.227 28.125C142.11 28.125 143.805 27.1131 143.805 25.4464C143.805 23.9583 142.705 23.3333 138.959 23.3036C133.548 23.2738 131.556 21.8155 131.556 18.4524C131.556 15.1488 134.44 13.006 138.989 13.006C141.902 13.006 143.924 13.6012 145.559 14.9702C145.946 15.3274 146.124 15.7143 146.124 16.1905C146.124 17.1429 145.529 17.7679 144.667 17.7679C144.311 17.7679 143.983 17.6488 143.746 17.4405C142.408 16.3691 140.892 15.8333 139.197 15.8333C136.432 15.8333 134.648 16.875 134.648 18.4821C134.708 19.8214 135.718 20.3274 139.286 20.3571Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M161.822 27.7976C160.811 29.8512 158.789 30.8929 156.143 30.8929C152.159 30.8929 149.751 28.3631 149.751 24.1369V9.31547C149.751 8.2738 150.346 7.6488 151.327 7.6488C152.308 7.6488 152.843 8.2738 152.843 9.31547V13.4524H159.592C160.543 13.4524 161.108 14.0179 161.108 14.9107C161.108 15.8036 160.543 16.3393 159.592 16.3393H152.813V24.2262C152.813 26.6071 154.092 28.006 156.262 28.006C157.719 28.006 158.64 27.3512 159.354 26.2202C159.592 25.8631 159.949 25.5655 160.573 25.5655C161.376 25.5655 162 26.1607 162 27.0536C162 27.3214 161.941 27.5893 161.822 27.7976Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M24.1112 19.9702C24.022 21.5476 23.4274 23.3333 20.5139 24.2262C15.6381 25.7441 12.8435 29.1369 11.8029 30.1786C10.4948 31.4881 9.45421 33.3036 8.74069 35.8036C7.84878 38.8988 7.04606 40 4.22169 40C1.873 40 0 38.125 0 35.8036C0 33.4821 1.36759 31.9048 4.19196 31.6071C10.8515 30.8631 15.6976 26.4583 15.6976 20.0893V19.9107C15.6976 13.5417 10.8515 9.13691 4.19196 8.39286C1.36759 8.09524 0 6.51786 0 4.19643C0 1.875 1.873 0 4.19196 0C7.01633 0 8.32446 1.60714 8.77042 4.19643C9.12718 6.33929 10.465 8.5119 11.7732 9.82143C12.8435 10.8631 15.6084 14.256 20.4841 15.7738C23.3977 16.6964 23.9923 18.4524 24.0815 20.0298V19.9702H24.1112Z",
                                    fill: "#17009A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3.0622 24.2262H3.95411C6.21361 24.2262 8.1758 22.5298 8.32445 20.2679C8.4731 17.8274 6.54064 15.8036 4.13249 15.8036C4.13249 15.8036 3.21086 15.7738 2.97301 15.8036C2.02165 15.8929 1.30812 16.5774 1.1892 17.5C1.01082 18.7798 1.01082 21.1607 1.1892 22.381C1.30812 23.3929 2.02165 24.1071 3.0622 24.2262Z",
                                    fill: "#17009A"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0_14_353",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "162",
                                    height: "40",
                                    fill: "white"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "contact-form-header",
                    children: "Ready to see how external data can transform your business?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                            fields: data.fields,
                            formData: formData,
                            changeData: changeData,
                            errors: errors,
                            className: "mt-7px",
                            classNameTextArea: "textarea-proper-request-demo mt-7px",
                            labelClassName: "input-label-style",
                            hideRequiredLabel: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "consent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsCheckbox/* TermsCheckbox */.H, {
                            text: data.form.consent,
                            checked: consent,
                            onChange: changeConsent,
                            error: errors.consent,
                            classNameForText: classNameForTextAgreement,
                            classNameMain: "terms_checkbox-request-demo",
                            classNameContainer: "terms_checkbox-request-demo-container",
                            classNameError: "terms_checkbox-request-demo-error"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                demystIcon: true,
                                variant: "secondary",
                                disabled: sending,
                                className: "width-100",
                                children: "Book demo"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/CustomerLogos.js + 4 modules
var CustomerLogos = __webpack_require__(50183);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/RequestDemoTemplate.jsx















var renderCustomerLogo = function(logo) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("logo", logo.isBrightLogo && "brightLogo"),
        style: logo.isAnz ? {
            marginTop: "0.5rem"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: false,
            src: logo.src,
            alt: logo.alt,
            width: logo.width,
            height: logo.height
        })
    }, logo.alt);
};
var DiscoveryForm = function(param) {
    var data = param.data, type = param.type, className = param.className;
    var ref = (0,react.useState)(false), modalOpen = ref[0], changeModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), errorModalOpen = ref1[0], changeErrorModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), consent = ref2[0], changeConsent = ref2[1];
    var ref3 = (0,react.useState)({}), formData = ref3[0], changeFormData = ref3[1];
    var ref4 = (0,react.useState)({}), errors = ref4[0], changeErrors = ref4[1];
    var ref5 = (0,react.useState)(false), sending = ref5[0], changeSending = ref5[1];
    var ref6 = (0,react.useState)(null), linkedInCookie = ref6[0], setLinkedInCookie = ref6[1];
    (0,react.useEffect)(function() {
        setLinkedInCookie(localStorage.getItem("li_fat_id"));
    }, []);
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = (0,formAttribution/* formAttribution */.e)(type === "report" ? "Data Discovery Report Request" : type === "contact" ? "Contact Form" : "Demo Request Form");
        data.fields.forEach(function(field) {
            preparedData[field.id] = formData[field.id];
        });
        return preparedData;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!((0,form_functions/* validate */.G)({
                            type: type,
                            formData: formData,
                            data: data,
                            changeErrors: changeErrors,
                            consent: consent
                        }) === true)) {
                            _ctx.next = 18;
                            break;
                        }
                        changeSending(true);
                        dataToSend = {
                            type: type,
                            formValues: preparedData()
                        };
                        linkedInCookie && (0,userTracking.sendLinkedInConversion)();
                        if (type === "contact") {
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Contact"
                            }, formData.email);
                        }
                        if (type === "request") {
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Request Demo"
                            }, formData.email);
                        }
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 10:
                        changeModalOpen(true);
                        changeSending(false);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](7);
                        changeErrorModalOpen(true);
                        changeSending(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    14
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var newFormData = {};
        data.fields.forEach(function(field) {
            newFormData[field.id] = "";
        });
        changeFormData(newFormData);
    }, []);
    var mobileScreenWidth = 30 * 16;
    (0,react.useEffect)(function() {
        if (true) {
            var isMobile = window.innerWidth <= mobileScreenWidth;
            var headerElement = document.querySelector("header");
            var footerElement = document.querySelector("footer");
            if (headerElement) {
                headerElement.remove();
            }
            if (footerElement) {
                footerElement.remove();
            }
            if (!isMobile) {
                document.body.style.overflowY = "hidden";
                return function() {
                    document.body.style.overflowY = "auto";
                };
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return changeModalOpen(false);
                }
            }),
            errorModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return changeErrorModalOpen(false);
                },
                type: "Error",
                fromContact: true
            }),
            [
                "contact",
                "request"
            ].includes(type) && typeof formData[data.fields[0].id] !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestDemoForm, {
                data: data,
                formData: formData,
                changeData: changeData,
                errors: errors,
                consent: consent,
                className: className,
                changeConsent: changeConsent,
                handleSubmit: handleSubmit,
                sending: sending,
                type: type,
                classNameForTextAgreement: "terms-agreement"
            })
        ]
    });
};
var RequestDemoTemplate = function(param) {
    var data = param.data, type = param.type;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("LandingHero-background-request-demo"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left-side",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoveryForm, {
                    data: data,
                    type: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-side",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "AlignSvgRequestDemo",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "x-button",
                            onClick: function() {
                                return router.back();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "22",
                                height: "21",
                                viewBox: "0 0 22 21",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M13.7789 10.5L21.4332 17.8064C22.1889 18.5277 22.1889 19.7377 21.4332 20.459C20.6776 21.1803 19.41 21.1803 18.6543 20.459L11 13.1526L3.34571 20.4357C2.59003 21.1571 1.32244 21.1571 0.566759 20.4357C-0.18892 19.7144 -0.18892 18.5044 0.566759 17.7831L8.22105 10.4767L0.566759 3.19363C-0.18892 2.4723 -0.18892 1.26233 0.566759 0.540997C1.32244 -0.180332 2.59003 -0.180332 3.34571 0.540997L11 7.84737L18.6299 0.540997C19.3856 -0.180332 20.6532 -0.180332 21.4089 0.540997C22.1645 1.26233 22.1645 2.4723 21.4089 3.19363L13.7789 10.5Z",
                                    fill: "#F4F3FF"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-right-side",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "align-text-and-logos",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "For over a decade Demyst has been powering some of the most critical bank and insurance applications around the world."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Demyst's purpose-built external data platform is relied upon by leading organizations."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "logo-group",
                                        children: CustomerLogos/* logos.default.map */.U["default"].map(renderCustomerLogo)
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/datasets/forms/book_demo.js
var book_demo = {
    label: "Fill out this form and we'll get back to you:",
    header: "Talk with sales",
    headerColor: "#8B80CD",
    fields: [
        {
            label: "Full name:",
            id: "full_name",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Company:",
            id: "company",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Business email address:",
            id: "email",
            type: "email",
            component: "input",
            required: true
        },
        {
            label: "Please share high level use case or data source requirements",
            id: "message",
            component: "textarea",
            required: false
        }, 
    ],
    form: {
        button_text: "Submit",
        consent: {
            beginning: "I agree to Demyst's ",
            link1_text: "Terms and Conditions",
            link1_url: "/terms-and-conditions",
            separator: " and ",
            link2_text: "Privacy Policy.",
            link2_url: "/privacy-policy"
        }
    },
    errors: {
        field_required: "This field is required!",
        incorrect_mail: "This email address is incorrect."
    }
}; // export const contact = {
 //   label: "Please fill out this form and we'll get back to you shortly:",
 //   header: "Contact us",
 //   headerColor: "#8B80CD",
 //   fields: [
 //     { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
 //     { label: "Business Email", id: "email", type: "email", component: "input", required: true },
 //     { label: "Company", id: "company", type: "text", component: "input", required: true },
 //     { label: "Role (optional)", id: "role", type: "text", component: "input", required: false },
 //     { label: "How can Demyst help you?", id: "message", component: "textarea", required: false },
 //   ],
 //   form: {
 //     button_text: "Submit",
 //     consent: {
 //       beginning: "I agree to Demyst's ",
 //       link1_text: "Terms and Conditions",
 //       link1_url: "/terms-and-conditions",
 //       separator: " and ",
 //       link2_text: "Privacy Policy.",
 //       link2_url: "/privacy-policy",
 //     },
 //   },
 //   errors: {
 //     field_required: "This field is required!",
 //     incorrect_mail: "This email address is incorrect.",
 //   },
 // };

;// CONCATENATED MODULE: ./pages/request-demo.jsx





var RequestDemoPage = function(param) {
    var allDataSources = param.allDataSources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/request-demo",
                title: meta/* meta.request.title */.$.request.title,
                description: meta/* meta.request.description */.$.request.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestDemoTemplate, {
                type: "request",
                dataSources: allDataSources,
                data: book_demo,
                headerColor: book_demo.headerColor
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var request_demo = (RequestDemoPage);


/***/ }),

/***/ 50183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt.png
/* harmony default export */ var Momnt = ({"src":"/_next/static/media/Momnt.30635708.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////zk3/////3v7Xzm4j3xb6ROC7wAAAAB3RSTlNYYkBNaG5HZO0z8gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABlJREFUeJwFwQcBAAAIAyDm6x9ZQJ0WsSPxAPEAGZmuqSMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/CincinnatiFinance.png
/* harmony default export */ var CincinnatiFinance = ({"src":"/_next/static/media/CincinnatiFinance.4bb80e30.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXEUVG0aVWwASmoAT2sAVVXFqwtiAAAABnRSTlMAKDMNUgYUvz2rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nG3LsREAMAyDQIGc/VfOuTfNVyRH2qXOQJMiwEsQ5Xg+BykAMrwb8LsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/NAB.svg
/* harmony default export */ var NAB = ({"src":"/_next/static/media/NAB.b100bc4e.svg","height":425,"width":875});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers-color.svg
var Farmers_color = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered-color.svg
var StandardChartered_color = __webpack_require__(18378);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz-color.svg
var Anz_color = __webpack_require__(15968);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt-color.png
/* harmony default export */ var Momnt_color = ({"src":"/_next/static/media/Momnt-color.a6d59b53.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUQLlgUMFd9WWjfg3OLX2kaM1nQfXFqAiexAAAAB3RSTlNcVEdAaGluDzj5NwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGRkZmJgZGRgYGBgY2FkZWAAAADeABp7a5gYAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/constants/CustomerLogos.js





// import IAG from "../landingPage/views/assets/logos/IAG.png";





var logos = {
    default: [
        {
            src: NAB.src,
            alt: "NAB",
            width: "150",
            height: "60"
        },
        {
            src: Anz/* default.src */.Z.src,
            alt: "ANZ",
            width: "100",
            height: "35",
            isAnz: true
        },
        {
            src: Momnt.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        },
        {
            src: StandardChartered/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Farmers/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        // { src: IAG.src, alt: "IAG", width: "80", height: "80" },
        {
            src: CincinnatiFinance,
            alt: "Cincinnati",
            width: "120",
            height: "120",
            isBrightLogo: true
        }, 
    ],
    color: [
        {
            src: Anz_color/* default.src */.Z.src,
            alt: "ANZ",
            width: "96",
            height: "31"
        },
        {
            src: Farmers_color/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        {
            src: StandardChartered_color/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Momnt_color.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        }, 
    ]
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 17609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TermsCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var TermsCheckbox = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text, error = param.error, _classNameForText = param.classNameForText, classNameForText = _classNameForText === void 0 ? "terms_checkbox-text" : _classNameForText, _classNameMain = param.classNameMain, classNameMain = _classNameMain === void 0 ? "terms_checkbox-main" : _classNameMain, _classNameContainer = param.classNameContainer, classNameContainer = _classNameContainer === void 0 ? "terms_checkbox-container" : _classNameContainer, _classNameError = param.classNameError, classNameError = _classNameError === void 0 ? "terms_checkbox-error" : _classNameError;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classNameMain,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "terms_checkbox-label",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classNameContainer,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "checkbox",
                                value: text,
                                checked: checked,
                                onChange: function() {
                                    return onChange(!checked);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "terms_checkbox-box"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: classNameForText,
                        children: [
                            text.beginning,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link1_url,
                                    children: text.link1_text
                                })
                            }),
                            text.separator,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link2_url,
                                    children: text.link2_text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classNameError,
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formAttribution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var formAttribution = function(body) {
    var landingPage = localStorage.getItem("landing_page");
    var landingPageDatetime = localStorage.getItem("landing_page_datetime");
    var landingPageFullUrl = localStorage.getItem("landing_page_full_url");
    var currentPagePath = localStorage.getItem("current_page_path");
    var currentPagePathDatetime = localStorage.getItem("current_page_path_datetime");
    var prevPagePath = localStorage.getItem("prev_page_path");
    var prevPagePathDatetime = localStorage.getItem("prev_page_path_datetime");
    var pageFlow = JSON.parse(localStorage.getItem("page_flow"));
    var sessionPageFlow = JSON.parse(sessionStorage.getItem("session_page_flow"));
    var gaAdCookie = localStorage.getItem("gaAd");
    var gaAdCookieUpdated = localStorage.getItem("gaAd_updated");
    var gaAdCookieCreated = localStorage.getItem("gaAd_created");
    var isProductKickingAss = (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/external-data/")) || (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/third-party-data/"));
    var googleAdsGclid = localStorage.getItem("gclid");
    var googleAdsGclidCreated = localStorage.getItem("gclid_created");
    var googleAdsGclidUpdated = localStorage.getItem("gclid_updated");
    var linkedInCookie = localStorage.getItem("li_fat_id");
    var linkedInCookieCreated = localStorage.getItem("li_fat_id_created");
    var linkedInCookieUpdated = localStorage.getItem("li_fat_id_updated");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmMediumCreated = localStorage.getItem("utm_medium_created");
    var utmMediumUpdated = localStorage.getItem("utm_medium_updated");
    var utmSource = localStorage.getItem("utm_source");
    var utmSourceCreated = localStorage.getItem("utm_source_created");
    var utmSourceUpdated = localStorage.getItem("utm_source_updated");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var utmCampaignCreated = localStorage.getItem("utm_campaign_created");
    var utmCampaignUpdated = localStorage.getItem("utm_campaign_updated");
    var utmContent = localStorage.getItem("utm_content");
    var utmContentCreated = localStorage.getItem("utm_content_created");
    var utmContentUpdated = localStorage.getItem("utm_content_updated");
    var utmTerm = localStorage.getItem("utm_term");
    var utmTermCreated = localStorage.getItem("utm_term_created");
    var utmTermUpdated = localStorage.getItem("utm_term_updated");
    var marketingSource = linkedInCookie ? "linkedin" : googleAdsGclid ? "google(cpc)" : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        body: body
    }, landingPage && {
        landing_page: landingPage
    }, landingPageFullUrl && {
        landing_page_full_url: landingPageFullUrl
    }, landingPageDatetime && {
        landing_page_datetime: landingPageDatetime
    }, currentPagePath && {
        current_page_path: currentPagePath
    }, currentPagePathDatetime && {
        current_page_path_datetime: currentPagePathDatetime
    }, prevPagePath && {
        prev_page_path: prevPagePath
    }, prevPagePathDatetime && {
        prev_page_path_datetime: prevPagePathDatetime
    }, sessionPageFlow && {
        session_page_flow: sessionPageFlow
    }, pageFlow && {
        macro_page_flow: pageFlow
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmMediumCreated && {
        utm_medium_created: utmMediumCreated
    }, utmMediumUpdated && {
        utm_medium_updated: utmMediumUpdated
    }, utmSource && {
        utm_source: utmSource
    }, utmSourceCreated && {
        utm_source_created: utmSourceCreated
    }, utmSourceUpdated && {
        utm_source_updated: utmSourceUpdated
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmCampaignCreated && {
        utm_campaign_created: utmCampaignCreated
    }, utmCampaignUpdated && {
        utm_campaign_updated: utmCampaignUpdated
    }, utmContent && {
        utm_content: utmContent
    }, utmContentCreated && {
        utm_content_created: utmContentCreated
    }, utmContentUpdated && {
        utm_content_updated: utmContentUpdated
    }, utmTerm && {
        utm_term: utmTerm
    }, utmTermCreated && {
        utm_term_created: utmTermCreated
    }, utmTermUpdated && {
        utm_term_updated: utmTermUpdated
    }, marketingSource && {
        marketing_source: marketingSource
    }, gaAdCookie && {
        gaAd: gaAdCookie
    }, gaAdCookieCreated && {
        gaAd_created: gaAdCookieCreated
    }, gaAdCookieUpdated && {
        gaAd_updated: gaAdCookieUpdated
    }, isProductKickingAss && {
        pikYa: isProductKickingAss
    }, googleAdsGclid && {
        gclid: googleAdsGclid
    }, googleAdsGclidCreated && {
        gclid_created: googleAdsGclidCreated
    }, googleAdsGclidUpdated && {
        gclid_updated: googleAdsGclidUpdated
    }, linkedInCookie && {
        li_fat_id: linkedInCookie
    }, linkedInCookieCreated && {
        li_fat_id_created: linkedInCookieCreated
    }, linkedInCookieUpdated && {
        li_fat_id_updated: linkedInCookieUpdated
    }, document.referrer && {
        referrer: document.referrer
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2777,5675,8540,9774,2888,179], function() { return __webpack_exec__(62037); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);